"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Brand = _ref => {
  let {
    branding,
    logoSrc,
    logoText
  } = _ref;
  const mmBranding = !branding || branding?.brandingOption === 'massMutual';
  if (mmBranding) {
    if (logoSrc === 'default') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mm-r-logo-lg-white",
        role: "img",
        "aria-label": logoText,
        "data-testid": "default-logo"
      });
    }
    return /*#__PURE__*/_react.default.createElement("img", {
      alt: logoText,
      src: logoSrc
    });
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "name"
    }, branding.subBrandTitle);
  }
};
Brand.propTypes = {
  branding: _propTypes.default.oneOf(['massMutual', 'subBranding']),
  logoSrc: _propTypes.default.string,
  logoText: _propTypes.default.string
};
Brand.defaultProps = {
  logoSrc: 'default'
};
var _default = exports.default = Brand;